import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import { clearPageInformation, setPageInformation, setPageViewSent } from '../../../../store/actions/UI';

import './style.scss';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';

const Success = () => {
  const PAGE_TITLE = 'Bedankt voor je bestelling | VeiligheidNL';
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const orderNumber = useSelector((state) => state.getIn(['uiInternal', 'prevOrderNumber'], ''));

  useEffect(() => {
    dispatch(clearPageInformation());
    dispatch(setPageInformation(PAGE_TITLE));
    dispatch(setPageViewSent(false));
  }, []);

  return (
    <>
      <Helmet
        htmlAttributes={{
          lang: DEFAULT_LANGUAGE,
        }}
      >
        <title>{PAGE_TITLE}</title>
      </Helmet>
      <div className="Success">
        <div className="Success__container">
          <div className="StepsProgressBar__step__number__done"><span><div className="icon icon-check icon-variant-2" /></span></div>

          <h2>{t('checkout.success.title')}</h2>
          <p>{t('checkout.success.email_confirm')}</p>
          <p>{t('checkout.success.order_number', { orderNumber: orderNumber })}</p>
          <p>{t('checkout.success.questions')}</p>

          <Button onClick={() => history.push('/')} className="Button Button--primary">{t('cart.back_to_home')}</Button>

        </div>
      </div>
    </>
  );
};

export default Success;
